/*eslint-disable no-loop-func */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Card, Row, Col, Form } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';

import { ClaimDetailsSVG } from '../../img/GlobalSVG';
import GetAdminConfiguration from '../../api/GetAdminConfig';
import APIEndpoints from '../../api/APIEndpoints';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import RetryAPI from '../../api/RetryAPI';
import ClientError from '../../errorhandling/ClientError';

import AdminUserDetails from '../../api/AdminUserDetails';
import MasterPermissions from '../../api/MasterPermissions';

import MemberAndDependent from './Sections/MemberAndDependent';
import WaysOfRegistration from './Sections/WaysOfRegistration';
import PersonalIdentification from './Sections/PersonalIdentification';

import { axiosInstance } from '../../../api/axios';
import DefaultPermission from './Sections/DefaultPermissions';
import {
  disableBreadCrumb,
  enableBreadCrumb,
  resetBreadCrumb,
} from '../../../redux/admin/breadCrumbSlice';
import Header from '../../components/common/Header/Header';
import RegistrationSetupSkeleton from './RegistrationSetupSkeleton';
import './Registrationsetup.scss';
import 'react-toastify/dist/ReactToastify.css';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import ToastMessage from '../common/ToastMessage';
import DualCoverageRegistration from './Sections/DualCoverageRegistration';
import ApprovalAffiliation from './Sections/ApprovalAffiliation';

const getAdminConfigData = '';
let getAdminConfigDataResp = '';
let insurerClientRec;
//let passwordRulesRec
let configFieldsRec;
let RegistrationSetUpRec;
const regSetupData = '';

class RegistrationSetUp extends Component {
  cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  constructor(props) {
    super(props);

    this.state = {
      LoadingRegSetup: true,
      SavingRegSetup: false,
      clientError: false,
      serverError: false,

      //Member and Dependents
      clientConfiguration: null,
      allowMember: false,
      allowDependent: false,
      minAge: 18,

      //dual coverage
      whileRegistrationAffiliation: false,
      postRegistrationAffiliation: false,

      //dual coverage approval registration
      isRegistrationApproval: false,
      selfAffiliation: false,

      //Password Rules
      pwdRulesOid: '',
      //pwdRulesPasswordMinLength: 12,
      //pwdRulesPasswordMaxLength: 18,
      //pwdRulesNoOfUpperCaseReqd: false,
      //pwdRulesNoOfLowerCaseReqd: false,
      //pwdRulesNoOfNumericsReqd: false,
      //pwdRulesNoOfSpecialCharactersReqd: false,
      //pwdRulesRestrictQWERTYLetters: false,
      //pwdRulesAllowSpacesInPassword: false,
      //pwdRulesNoOfLastPasswordsUsed: 0,
      //pwdRulesAllowUnlockDisabledLogin: false,
      //JMP-1382 removed as per Amit's request
      //pwdRulesInvalidAttemptRestriction: false,
      //pwdRulesNoOfInvalidPasswordRecoveries: 0,
      //pwdRulesNoOfInvalidAttempts: 3,

      //Two Factor Authentication
      TwoFARequired: false,
      //JMP-1301
      //InvalidOTPAttemptRestriction: false,
      OTPLength: 0,
      OTPExpiresIn: 0,
      FirstTimeRegistration: 0,
      Login: false,
      FrequencyForTwoFA: 0,
      AllowSetTrustedDevice: false,
      FrequencyForTrustedDevice: 0,
      FrequencyTypeForTrustedDevice: 'Days',
      InvalidOTPAttempts: 0,

      //Sections to render
      memberAndDependent: false,
      waysOfRegistration: false,
      defaultPermission: false,
      personalIdentification: false,
      dualCoverageRegistration: false,
      dualCoverageAffiliationPermission: false,
      dualCoverageApprovalPermission: false,

      //sections editable
      memberAndDependentEditable: true,
      waysOfRegistrationEditable: true,
      defaultPermissionEditable: true,
      personalIdentificationEditable: true,

      //save button
      editReg: false,

      //breadcrumbs
      blobBreadcrumb: '',
      empBreadcrumb: '',
      defaultMemberRole: '',
      defaultDependentRole: '',
      waysOfReg: [true, true, true, true, true, true],
      errorValidation: {
        waysOfRegMember: false,
        waysOfRegDependent: false,
        personalIdentityMemberMemberID: false,
        personalIdentityMemberUserInfo: false,
        personalIdentityDependentMemberID: false,
        personalIdentityDependentUserInfo: false,
        dependentMinimumAge: false,
        memberMinField: false,
        dependentMinField: false,
      },
      loadDefaultPermission: false,
    };
    document.addEventListener('employer-update', this.rerenderPage);
  }

  resetErrorValidation = () => {
    this.setState({
      errorValidation: {
        ...this.state.errorValidation,
        waysOfRegMember: false,
        waysOfRegDependent: false,
        personalIdentityMemberMemberID: false,
        personalIdentityMemberUserInfo: false,
        personalIdentityDependentMemberID: false,
        personalIdentityDependentUserInfo: false,
        dependentMinimumAge: false,
        memberMinField: false,
        dependentMinField: false,
      },
    });
  };

  //Method that sets up default role for the registration
  setDefaultRole = (userType, roleName) => {
    if (userType === 'Member') {
      this.setState((prevState) => {
        return {
          ...prevState,
          defaultMemberRole: roleName,
        };
      });
    } else if (userType === 'Dependent') {
      this.setState((prevState) => {
        return {
          ...prevState,
          defaultDependentRole: roleName,
        };
      });
    }
  };

  async componentDidMount() {
    //TODO : reset location breadcrumb
    //TODO : disable location breadcrumb
    this.props.resetBreadCrumb({ breadCrumbType: 'location' });
    this.props.disableBreadCrumb({ breadCrumbType: 'location' });
    window.scrollTo(0, 0);
    await this.getAdminConfig();
    this.getPageConfig();
  }

  componentDidUpdate(prevProps, prevState) {
    //if (this.state.blobBreadcrumb !== this.props.blockOfBusiness.key ||
    //this.state.empBreadcrumb !== this.props.employer.key) {
    //this.setState({
    //blobBreadcrumb: this.props.blockOfBusiness.key,
    //empBreadcrumb: this.props.employer.key,
    //})
    //this.getPageConfig()
    //}
    if (
      prevProps.blockOfBusiness.key !== this.props.blockOfBusiness.key ||
      prevProps.employer.key !== this.props.employer.key
    ) {
      //alert('851');
      this.getPageConfig();
    }
  }

  componentWillUnmount() {
    this.props.enableBreadCrumb({ breadCrumbType: 'location' });
  }

  //Methods that set the state from the API Response
  setRegistrationTypes = () => {
    if (
      typeof getAdminConfigDataResp.Response.InsurerClientSettings !=
      'undefined'
    ) {
      //this.setState({ allowMember: getAdminConfigDataResp.Response.InsurerClientSettings.AllowMembersToRegister === "true" ? true : false });
      //this.setState({ allowDependent: getAdminConfigDataResp.Response.InsurerClientSettings.AllowDependentsToRegister === "true" ? true : false });
      //this.setState({ minAge: getAdminConfigDataResp.Response.InsurerClientSettings.DependentRegistrationAgeLimit || 1 });
      this.setState({
        allowMember:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .AllowMembersToRegister === 'true'
            ? true
            : false,
        allowDependent:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .AllowDependentsToRegister === 'true'
            ? true
            : false,
        minAge:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .DependentRegistrationAgeLimit || 1,
      });
    }
  };

  setDualCoverageRegistration = () => {
    if (
      typeof getAdminConfigDataResp.Response.InsurerClientSettings !=
      'undefined'
    ) {
      this.setState({
        whileRegistrationAffiliation:
          getAdminConfigDataResp?.Response?.InsurerClientSettings
            ?.AllowDualCoverageOnRegistration === true
            ? true
            : false,
        postRegistrationAffiliation:
          getAdminConfigDataResp?.Response?.InsurerClientSettings
            ?.AllowDualCoverageAfterRegistration === true
            ? true
            : false,
      });
    }
  };

  setApprovalAffiliation = () => {
    if (
      typeof getAdminConfigDataResp.Response.InsurerClientSettings !=
      'undefined'
    ) {
      this.setState({
        isRegistrationApproval:
          getAdminConfigDataResp?.Response?.InsurerClientSettings
            ?.DualCoverageApproveRegistrationAffiliation === true
            ? true
            : false,
        selfAffiliation:
          getAdminConfigDataResp?.Response?.InsurerClientSettings
            ?.DualCoverageApproveSelfAffiliation === true
            ? true
            : false,
      });
    }
  };

  setPasswordRules = () => {
    if (typeof getAdminConfigDataResp.Response.PasswordRules != 'undefined') {
      this.setState({
        //pwdRulesPasswordMinLength: getAdminConfigDataResp.Response.PasswordRules.PasswordMinLength || 12,
        //pwdRulesPasswordMaxLength: getAdminConfigDataResp.Response.PasswordRules.PasswordMaxLength || 25,
        //pwdRulesNoOfUpperCaseReqd: getAdminConfigDataResp.Response.PasswordRules.NoOfUpperCaseReqd === 1 ? true : false,
        //pwdRulesNoOfNumericsReqd: getAdminConfigDataResp.Response.PasswordRules.NoOfNumericsReqd === 1 ? true : false,
        //pwdRulesNoOfSpecialCharactersReqd: getAdminConfigDataResp.Response.PasswordRules.NoOfSpecialCharactersReqd === 1 ? true : false,
        //pwdRulesRestrictQWERTYLetters: getAdminConfigDataResp.Response.PasswordRules.RestrictQWERTYLetters,
        //pwdRulesAllowSpacesInPassword: getAdminConfigDataResp.Response.PasswordRules.AllowSpacesInPassword,
        //pwdRulesAllowUnlockDisabledLogin: getAdminConfigDataResp.Response.PasswordRules.AllowUnlockDisabledLogin === 'true' ? true : false,
        //JMP-1382 removed as Amit's request
        //pwdRulesInvalidAttemptRestriction: getAdminConfigDataResp.Response.PasswordRules.InvalidAttemptRestriction === "true" ? true : false,
        //pwdRulesNoOfInvalidPasswordRecoveries: getAdminConfigDataResp.Response.PasswordRules.NoOfInvalidPasswordRecoveries,
        //pwdRulesNoOfInvalidAttempts: getAdminConfigDataResp.Response.PasswordRules.NoOfInvalidAttempts || 3
      });
    }
  };

  setTFA = () => {
    if (
      typeof getAdminConfigDataResp.Response.InsurerClientSettings !=
      'undefined'
    ) {
      this.setState({
        TwoFARequired:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .TwoFARequired === 'true'
            ? true
            : false,
        //JMP-1301
        //InvalidOTPAttemptRestriction: getAdminConfigDataResp.Response.InsurerClientSettings.InvalidAttemptRestriction === "true" ? true : false,
        OTPLength:
          getAdminConfigDataResp.Response.InsurerClientSettings.OTPLength || 6,
        OTPExpiresIn:
          getAdminConfigDataResp.Response.InsurerClientSettings.OTPExpiresIn ||
          1,
        FirstTimeRegistration:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .FirstTimeRegistration,
        Login: getAdminConfigDataResp.Response.InsurerClientSettings.Login,
        FrequencyForTwoFA:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .FrequencyForTwoFA,
        AllowSetTrustedDevice:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .AllowSetTrustedDevice,
        FrequencyForTrustedDevice:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .FrequencyForTrustedDevice || 30,
        FrequencyTypeForTrustedDevice:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .FrequencyTypeForTrustedDevice,
        InvalidOTPAttempts:
          getAdminConfigDataResp.Response.InsurerClientSettings
            .InvalidOTPAttempts || 3,
      });
    }
  };

  validateConfigFields = async (values, errors) => {
    this.setState({ SavingRegSetup: true });
    this.resetErrorValidation();
    let validationErrorStatus = [];
    let validationError = false;
    let memberValidationErrorWaysOfReg = false;
    let dependentValidationErrorWaysOfReg = false;
    let minimumAgeError = false;
    let MemberUserInfoMinFields = false;
    let DependentUserInfoMinFields = false;

    if (this.props.employer.key === 'all') {
      this.saveConfigurationFields(values);
      this.saveInsuranceClientSettings(values);
      validationErrorStatus = configFieldsRec.ConfigurableFields.map(
        (item, index) => {
          if (
            item['RegistrationBy'] === 'MemberID' &&
            (this.state.waysOfReg[1] === true ||
              this.state.waysOfReg[4] === true) &&
            ((item['MemberType'] === 'Employee' && values.allowMember) ||
              (item['MemberType'] === 'Dependent' && values.allowDependent))
          ) {
            let validationFieldCount = 0;
            for (const key in item) {
              if (item[key] === 'Visible' || item[key] === 'Required') {
                validationFieldCount++;
              }
            }
            if (validationFieldCount <= 2 || validationFieldCount > 10) {
              validationError = true;
              return `${item['MemberType']},${item['RegistrationBy']}`;
            }
          }
          if (
            item['RegistrationBy'] === 'UserInfo' &&
            (this.state.waysOfReg[2] === true ||
              this.state.waysOfReg[5] === true) &&
            ((item['MemberType'] === 'Employee' && values.allowMember) ||
              (item['MemberType'] === 'Dependent' && values.allowDependent))
          ) {
            let validationFieldCount = 0;
            for (const key in item) {
              if (item[key] === 'Required') {
                validationFieldCount++;
              }
            }
            //console.log('validationFieldCount', validationFieldCount);
            //console.log(
            //'item[NumberOfItemsToMatch]',
            //item['NumberOfItemsToMatch'],
            //);

            //console.log('item', item);
            //console.log(
            //'GetAdminConfiguration.NumberOfItemsToMatch',
            //GetAdminConfiguration,
            //);
            if (
              validationFieldCount <= item['NumberOfItemsToMatch'] - 1 ||
              validationFieldCount > 12
            ) {
              validationError = true;
              return `${item['MemberType']},${item['RegistrationBy']}`;
            }

            const regEx = new RegExp('^([1-9]|1[0-8])$');
            if (index === 1 && this.state.waysOfReg[index]) {
              MemberUserInfoMinFields = !regEx.test(
                item['NumberOfItemsToMatch'],
              );
            }
            if (index === 3) {
              DependentUserInfoMinFields = !regEx.test(
                item['NumberOfItemsToMatch'],
              );
            }
          }
        },
      );
      memberValidationErrorWaysOfReg =
        values.allowMember &&
        !insurerClientRec.InsurerClientSettings
          .MemberRegistrationRequiredMemberID &&
        !insurerClientRec.InsurerClientSettings
          .MemberRegistrationRequiredFindMyAccount;
      dependentValidationErrorWaysOfReg =
        values.allowDependent &&
        !insurerClientRec.InsurerClientSettings
          .DependentRegistrationRequiredMemberID &&
        !insurerClientRec.InsurerClientSettings
          .DependentRegistrationRequiredFindMyAccount;
    }

    const regEx = new RegExp('^[1-9][0-9]?$|^100$');
    minimumAgeError = !regEx.test(values.minAge);

    const parseValidateError = validationErrorStatus
      .filter((item) => item !== undefined)
      .map((item) => {
        const [memberType, RegType] = item.split(',');
        if (memberType === 'Employee') {
          if (RegType === 'MemberID') {
            return { memberType: 'For Member', regType: 'For Member ID' };
          } else if (RegType === 'UserInfo') {
            return {
              memberType: 'For Member',
              regType: 'For “Find my account”',
            };
          } else {
            return null;
          }
        } else if (memberType === 'Dependent') {
          if (RegType === 'MemberID') {
            return { memberType: 'For Dependent', regType: 'For Member ID' };
          } else if (RegType === 'UserInfo') {
            return {
              memberType: 'For Dependent',
              regType: 'For “Find my account”',
            };
          } else {
            return null;
          }
        }
      });

    if (
      validationError ||
      memberValidationErrorWaysOfReg ||
      dependentValidationErrorWaysOfReg ||
      minimumAgeError ||
      MemberUserInfoMinFields ||
      DependentUserInfoMinFields
    ) {
      this.setState({ SavingRegSetup: false });

      toast.error(
        <ToastMessage
          type="error"
          title="Error Occurred While Setting up Registration!"
          subTitle="Minimum criteria not met in - Personal Identification section +2 more."
        />,
      );

      minimumAgeError &&
        this.setState({
          errorValidation: {
            ...this.state.errorValidation,
            dependentMinimumAge: true,
          },
        });

      MemberUserInfoMinFields &&
        this.setState({
          errorValidation: {
            ...this.state.errorValidation,
            memberMinField: true,
          },
        });

      DependentUserInfoMinFields &&
        this.setState({
          errorValidation: {
            ...this.state.errorValidation,
            dependentMinField: true,
          },
        });

      memberValidationErrorWaysOfReg &&
        this.setState({
          errorValidation: {
            ...this.state.errorValidation,
            waysOfRegMember: true,
          },
        });

      dependentValidationErrorWaysOfReg &&
        this.setState({
          errorValidation: {
            ...this.state.errorValidation,
            waysOfRegDependent: true,
          },
        });

      validationErrorStatus
        .filter((item) => item !== undefined)
        .map((item) => {
          const [memberType, RegType] = item.split(',');
          memberType === 'Employee' &&
            RegType === 'MemberID' &&
            this.setState({
              errorValidation: {
                ...this.state.errorValidation,
                personalIdentityMemberMemberID: true,
              },
            });
          memberType === 'Employee' &&
            RegType === 'UserInfo' &&
            this.setState({
              errorValidation: {
                ...this.state.errorValidation,
                personalIdentityMemberUserInfo: true,
              },
            });
          memberType === 'Dependent' &&
            RegType === 'MemberID' &&
            this.setState({
              errorValidation: {
                ...this.state.errorValidation,
                personalIdentityDependentMemberID: true,
              },
            });
          memberType === 'Dependent' &&
            RegType === 'UserInfo' &&
            this.setState({
              errorValidation: {
                ...this.state.errorValidation,
                personalIdentityDependentUserInfo: true,
              },
            });
        });

      return new Promise((res, rej) => {
        rej(validationErrorStatus);
      });
    } else {
      this.setState({ SavingRegSetup: false });

      return new Promise((res, rej) => {
        res('No issues');
      });
    }
  };

  //Methods that call the api with the updated state
  RegistrationSave = async (values) => {
    this.setState({ SavingRegSetup: true });
    //if (Breadcrumbs.getEmployerBreadcrumb().key === "all") {
    if (this.props.employer.key === 'all') {
      this.saveInsuranceClientSettings(values);
      this.saveConfigurationFields(values);
      const defaultRoleUpdation = { ...insurerClientRec };
      defaultRoleUpdation.InsurerClientSettings.DefaultMemberRole =
        this.state.defaultMemberRole != undefined
          ? this.state.defaultMemberRole
          : 'Member Default';
      defaultRoleUpdation.InsurerClientSettings.DefaultDependentRole =
        this.state.defaultDependentRole != undefined
          ? this.state.defaultDependentRole
          : 'Dependent Default';
      RegistrationSetUpRec = { ...defaultRoleUpdation, ...configFieldsRec };
      this.AddOrUpdateRegistrationSetup();
    } else {
      this.saveMemberAndDependentSettings(values);
    }
  };

  saveInsuranceClientSettings = (values) => {
    GetAdminConfiguration.AllowMembersToRegister = values.allowMember;
    GetAdminConfiguration.AllowDependentsToRegister = values.allowDependent;
    GetAdminConfiguration.DependentRegistrationAgeLimit = values.minAge;
    GetAdminConfiguration.FrequencyForTwoFA = values.FrequencyForTwoFA;
    GetAdminConfiguration.AllowSetTrustedDevice = values.AllowSetTrustedDevice;
    GetAdminConfiguration.AllowDualCoverageOnRegistration =
      values.whileRegistrationAffiliation;
    GetAdminConfiguration.AllowDualCoverageAfterRegistration =
      values.postRegistrationAffiliation;
    GetAdminConfiguration.DualCoverageApproveRegistrationAffiliation =
      values.isRegistrationApproval;
    GetAdminConfiguration.DualCoverageApproveSelfAffiliation =
      values.selfAffiliation;

    insurerClientRec = {
      InsurerClientSettings: {
        oid: GetAdminConfiguration.insuranceClientOid,
        AllowMembersToRegister: GetAdminConfiguration.AllowMembersToRegister,
        DefaultMemberRole: 'Member Default', //GetAdminConfiguration.DefaultMemberRole,
        AllowDependentsToRegister:
          GetAdminConfiguration.AllowDependentsToRegister,
        DefaultDependentRole: 'Dependent Default', //GetAdminConfiguration.DefaultDependentRole,
        DependentRegistrationAgeLimit:
          GetAdminConfiguration.DependentRegistrationAgeLimit,
        TwoFARequired: GetAdminConfiguration.TwoFARequired,
        FirstTimeRegistration: GetAdminConfiguration.FirstTimeRegistration,
        Login: GetAdminConfiguration.Login,
        FrequencyForTwoFA: GetAdminConfiguration.FrequencyForTwoFA,
        AllowSetTrustedDevice: GetAdminConfiguration.AllowSetTrustedDevice,
        FrequencyForTrustedDevice:
          GetAdminConfiguration.FrequencyForTrustedDevice,
        FrequencyTypeForTrustedDevice:
          GetAdminConfiguration.FrequencyTypeForTrustedDevice,
        InvalidOTPAttempts: GetAdminConfiguration.InvalidOTPAttempts,
        OTPExpiresIn: GetAdminConfiguration.OTPExpiresIn,
        OTPLength: GetAdminConfiguration.OTPLength,
        MemberRegistrationRequiredMemberID: GetAdminConfiguration.WaysOfReg[1],
        MemberRegistrationRequiredFindMyAccount:
          GetAdminConfiguration.WaysOfReg[2],
        DependentRegistrationRequiredMemberID:
          GetAdminConfiguration.WaysOfReg[4],
        DependentRegistrationRequiredFindMyAccount:
          GetAdminConfiguration.WaysOfReg[5],
        AllowDualCoverageOnRegistration: values.whileRegistrationAffiliation,
        AllowDualCoverageAfterRegistration: values.postRegistrationAffiliation,
        DualCoverageApproveRegistrationAffiliation:
          values.isRegistrationApproval,
        DualCoverageApproveSelfAffiliation: values.selfAffiliation,
      },
    };
  };

  saveConfigurationFields = (values) => {
    const configurableFields = [];
    for (
      let iIndex = 0;
      iIndex < GetAdminConfiguration.RegMethods?.length;
      iIndex++
    ) {
      if (
        ((this.state.waysOfReg[iIndex] ||
          (iIndex === 1 && !this.state.waysOfReg[iIndex])) &&
          [1, 2].includes(iIndex) &&
          values.allowMember) ||
        (this.state.waysOfReg[iIndex] &&
          [4, 5].includes(iIndex) &&
          values.allowDependent)
      ) {
        if (typeof GetAdminConfiguration.SSN[iIndex] == 'undefined')
          GetAdminConfiguration.SSN[iIndex] = 'Invisible';
        configurableFields.push({
          OID: GetAdminConfiguration.Oid[iIndex],
          RegistrationBy: GetAdminConfiguration.RegistrationBy[iIndex],
          FirstName: GetAdminConfiguration.FirstName[iIndex],
          LastName: GetAdminConfiguration.LastName[iIndex],
          DateOfBirth: GetAdminConfiguration.DateOfBirth[iIndex],
          Email: GetAdminConfiguration.Email[iIndex],
          AddressLine1: GetAdminConfiguration.AddressLine1[iIndex],
          AddressLine2: GetAdminConfiguration.AddressLine2[iIndex],
          City: GetAdminConfiguration.City[iIndex],
          State: GetAdminConfiguration.State[iIndex],
          PostalCode: GetAdminConfiguration.PostalCode[iIndex],
          Relationship: GetAdminConfiguration.Relationship[iIndex],
          PhoneNumber: GetAdminConfiguration.PhoneNumber[iIndex],
          ClientID: GetAdminConfiguration.ClientID[iIndex],
          ClientName: GetAdminConfiguration.ClientName[iIndex],
          PlanID: GetAdminConfiguration.PlanID[iIndex],
          CertificateNumber: GetAdminConfiguration.CertificateNumber[iIndex],
          SocialSecurityNumber: GetAdminConfiguration.SSN[iIndex],
          AlternateID1: GetAdminConfiguration.AlternateID1[iIndex],
          AlternateID2: GetAdminConfiguration.AlternateID2[iIndex],
          MedicareID: GetAdminConfiguration.MedicareID[iIndex],
          MemberType: GetAdminConfiguration.MemberType[iIndex],
          NumberOfItemsToMatch:
            GetAdminConfiguration.NumberOfItemsToMatch[iIndex],
          WaysOfReg: GetAdminConfiguration.waysOfReg,
        });
      }
    }

    configFieldsRec = {
      ConfigurableFields: configurableFields,
    };
  };

  AddOrUpdateRegistrationSetup = async () => {
    let iIndex;
    let regSetupResponse = null,
      regSetupDataResp;
    let EncrptedResp;

    RetryAPI.setResponseReceived(false);
    RetryAPI.resetRetryCount();
    while (RetryAPI.performRetry()) {
      try {
        if (GetAdminConfiguration.insuranceClientOid == null) {
          EncrptedResp = await axiosInstance.post(
            APIEndpoints.postAdminConfigResources(),
            RegistrationSetUpRec,
          );
        } else {
          EncrptedResp = await axiosInstance.put(
            APIEndpoints.putAdminConfigResources(),
            RegistrationSetUpRec,
          );
        }

        regSetupResponse = EncrptedResp;

        regSetupDataResp = regSetupResponse.data;

        if (
          regSetupResponse.status == HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
          regSetupResponse.status == HttpSuccessCodes.HTTP_SUCCESS_CODE_201
        ) {
          RetryAPI.resetRetryCount();
          RetryAPI.setResponseReceived(true);
        } else {
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(regSetupResponse.status);
        }

        if (RetryAPI.getResponseReceived()) break;
      } catch (error) {
        let errorMessage = '';
        //var requestAborted = '';

        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
    }

    if (RetryAPI.retryFailed()) {
      const errorCode = RetryAPI.getErrorCode();
      HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

      //Process Client Errors
      if (
        HttpErrorHandler.ProcessedClientErrors(
          errorCode,
          'view resetPwdResponse. ',
        )
      ) {
        toast.error(
          <ToastMessage
            type="error"
            title="Registration Setup."
            subTitle="Error occurred while saving Registration Setup."
          />,
        );
        //Display Error Message -No claims submitted in the past six months.
        this.setState({ clientError: true });
        this.setState({ SavingRegSetup: false });
      } else {
        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your resetPwdResponse now.',
          )
        ) {
          this.setState({ serverError: true });
        }
      }
    } else {
      toast.success(
        <ToastMessage
          title="Registration Setup"
          subTitle="Registration Setup was saved successfully."
          type="success"
        />,
      );

      this.setState({ SavingRegSetup: false });
    }
  };

  saveMemberAndDependentSettings = async (values) => {
    const refreshToken = '',
      ClientConfigurationAPI = '';
    let ClientConfigurationResponse = null;

    if (
      values.clientConfiguration === null &&
      this.props.employer.key !== 'all'
    ) {
      try {
        const ClientConfigurationResponse = await axiosInstance.post(
          APIEndpoints.postClientConfigResources(),
          {
            //Client_OID: this.state.empBreadcrumb,
            Client_OID: this.props.employer.key,
            AllowMembersToRegister: values.allowMember,
            AllowDependentsToRegister: values.allowDependent,
            DependentRegistrationAgeLimit: values.minAge,
            DefaultMemberRole: this.state.defaultMemberRole,
            DefaultDependentRole: this.state.defaultDependentRole,
          },
        );
        const ClientConfigurationtData = ClientConfigurationResponse.data;

        if (
          ClientConfigurationResponse.status ==
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
          ClientConfigurationResponse.status ==
            HttpSuccessCodes.HTTP_SUCCESS_CODE_201
        ) {
          toast.success(
            <ToastMessage
              type="success"
              title="Member and Dependent"
              subTitle="Employer Settings were saved successfully."
            />,
          );
          this.setState({ SavingRegSetup: false });
        }
      } catch (error) {
        let errorMessage = '';
        let requestAborted = '';
        if (error) {
          errorMessage = error.toString();
          requestAborted = errorMessage.match(/aborted/i);
        }
        toast.error(
          <ToastMessage
            type="error"
            title="Registration Setup."
            subTitle="Error occurred while saving Registration Setup."
          />,
        );
        this.setState({ SavingRegSetup: false });
        return false;
      }
    } else if (
      values.clientConfiguration !== null &&
      this.props.employer.key !== 'all'
    ) {
      //else if (values.clientConfiguration !== null && Breadcrumbs.getEmployerBreadcrumb().key !== "all") {
      try {
        const EncrptedResp = await axiosInstance.put(
          APIEndpoints.putClientConfigResources(),
          {
            OID: values.clientConfiguration,
            Client_OID: this.props.employer.key,
            AllowMembersToRegister: values.allowMember,
            AllowDependentsToRegister: values.allowDependent,
            DependentRegistrationAgeLimit: values.minAge,
            DefaultMemberRole: this.state.defaultMemberRole,
            DefaultDependentRole: this.state.defaultDependentRole,
          },
        );
        ClientConfigurationResponse = EncrptedResp;

        const ClientConfigurationtData = ClientConfigurationResponse.data;
        if (
          ClientConfigurationResponse.status ==
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          toast.success(
            <ToastMessage
              type="success"
              title="Member and Dependent"
              subTitle="Employer Settings were saved successfully."
            />,
          );
          this.setState({ SavingRegSetup: false });
        }
      } catch (error) {
        let errorMessage = '';
        let requestAborted = '';
        if (error) {
          errorMessage = error.toString();
          requestAborted = errorMessage.match(/aborted/i);
        }
        toast.error(
          <ToastMessage
            type="error"
            title="Registration Setup."
            subTitle="Error occurred while saving Registration Setup."
          />,
        );
        this.setState({ SavingRegSetup: false });
        return false;
      }
    }
  };

  //API that gets the admin config values
  getAdminConfig = async () => {
    GetAdminConfiguration.setAdminConfigurationResp(null);

    RetryAPI.setResponseReceived(false);
    RetryAPI.resetRetryCount();
    while (RetryAPI.performRetry()) {
      try {
        const getAdminConfigResponse = await axiosInstance.get(
          this.cacheBuster(APIEndpoints.getAdminConfigResources()),
        );

        getAdminConfigDataResp = getAdminConfigResponse.data;

        if (
          getAdminConfigResponse.status ==
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          //debugger;
          GetAdminConfiguration.setAdminConfigurationResp(
            getAdminConfigDataResp,
          );
          this.setState((prevState) => {
            return {
              ...prevState,
              defaultMemberRole:
                getAdminConfigDataResp.Response.InsurerClientSettings
                  .DefaultMemberRole,
              defaultDependentRole:
                getAdminConfigDataResp.Response.InsurerClientSettings
                  .DefaultDependentRole,
            };
          });
          RetryAPI.resetRetryCount();
          RetryAPI.setResponseReceived(true);
          GetAdminConfiguration.ParseInsuranceClientSettings();
          GetAdminConfiguration.ParseAdminConfiguration();
          GetAdminConfiguration.ParsePasswordRules();
          GetAdminConfiguration.ParseResetOptions();
          this.setRegistrationTypes();
          this.setDualCoverageRegistration();
          this.setApprovalAffiliation();
          this.setPasswordRules();
          this.setTFA();
        } else {
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(getAdminConfigResponse.status);
        }

        if (RetryAPI.getResponseReceived()) break;
      } catch (error) {
        let errorMessage = '';
        //var requestAborted = '';

        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
    }

    if (RetryAPI.retryFailed()) {
      const errorCode = RetryAPI.getErrorCode();
      HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

      //Process Client Errors
      if (
        HttpErrorHandler.ProcessedClientErrors(
          errorCode,
          'view getAdminConfigResponse. ',
        )
      ) {
        //Display Error Message -No claims submitted in the past six months.
        this.setState({ clientError: true, LoadingRegSetup: false });
        //this.setState({ LoadingRegSetup: false });
      } else {
        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your getAdminConfigResponse now.',
          )
        ) {
          this.setState({ serverError: true });
        }
      }
      return;
    } else {
      this.setState({ LoadingRegSetup: false });
    }
  };

  //Determines which sections to render
  getPageConfig = () => {
    const response = AdminUserDetails.getUserDetailResp();

    //Blob selected but no Employer Selected Configuration
    if (
      this.props.blockOfBusiness.key !== 'all' &&
      this.props.employer.key === 'all' &&
      response?.Response?.User?.UserType !== 'Client'
    ) {
      toast.info(
        <ToastMessage
          type="info"
          title="Registration Setup."
          subTitle="Please Select an Employer"
        />,
      );
      this.setState({
        memberAndDependent: false,
        waysOfRegistration: false,
        defaultPermission: false,
        personalIdentification: false,
        dualCoverageRegistration: false,
        dualCoverageAffiliationPermission: false,
        dualCoverageApprovalPermission: false,

        memberAndDependentEditable: false,
        waysOfRegistrationEditable: false,
        defaultPermissionEditable: false,
        personalIdentificationEditable: false,

        editReg: false,
      });
    } else if (response?.Response?.User?.SuperUser) {
      if (this.props.employer.key === 'all') {
        this.setState({
          memberAndDependent: true,
          waysOfRegistration: true,
          defaultPermission: true,
          personalIdentification: true,
          dualCoverageRegistration: true,
          dualCoverageAffiliationPermission: true,
          dualCoverageApprovalPermission: true,

          memberAndDependentEditable: true,
          waysOfRegistrationEditable: true,
          defaultPermissionEditable: true,
          personalIdentificationEditable: true,

          editReg: true,
        });
      } else {
        this.setState({
          memberAndDependent: true,
          waysOfRegistration: false,
          defaultPermission: true,
          personalIdentification: false,
          dualCoverageRegistration: false,
          dualCoverageAffiliationPermission: false,
          dualCoverageApprovalPermission: false,

          memberAndDependentEditable: true,
          waysOfRegistrationEditable: false,
          defaultPermissionEditable: true,
          personalIdentificationEditable: false,
          editReg: true,
        });
      }
    } else if (response?.Response?.User?.UserType === 'Client') {
      this.setState({
        memberAndDependent: MasterPermissions.CheckPermission(
          'View Registration Configuration',
        ),
        waysOfRegistration: false,
        defaultPermission: false,
        personalIdentification: false,
        dualCoverageRegistration: false,
        dualCoverageAffiliationPermission: false,
        dualCoverageApprovalPermission: false,
        memberAndDependentEditable: MasterPermissions.CheckPermission(
          'Edit Registration Configuration',
        ),
        waysOfRegistrationEditable: false,
        defaultPermissionEditable: false,
        personalIdentificationEditable: false,
        editReg: MasterPermissions.CheckPermission(
          'Edit Registration Configuration',
        ),
      });
    } else if (response?.Response?.User?.UserType === 'Insurer') {
      if (this.props.employer.key === 'all') {
        this.setState({
          memberAndDependent: MasterPermissions.CheckPermission(
            'View Registration Configuration',
          ),
          waysOfRegistration: MasterPermissions.CheckPermission(
            'View Registration Configuration',
          ),
          defaultPermission: MasterPermissions.CheckPermission(
            'View Registration Configuration',
          ),
          personalIdentification: MasterPermissions.CheckPermission(
            'View Registration Configuration',
          ),
          dualCoverageRegistration: MasterPermissions.CheckPermission(
            'Affiliate Dual Coverage',
          ),
          dualCoverageAffiliationPermission: MasterPermissions.CheckPermission(
            'Configure Dual Coverage Affiliation',
          ),
          dualCoverageApprovalPermission: MasterPermissions.CheckPermission(
            'Configure Approval for Dual Coverage',
          ),
          memberAndDependentEditable: MasterPermissions.CheckPermission(
            'Edit Registration Configuration',
          ),
          waysOfRegistrationEditable: MasterPermissions.CheckPermission(
            'Edit Registration Configuration',
          ),
          defaultPermissionEditable: MasterPermissions.CheckPermission(
            'Edit Registration Configuration',
          ),
          personalIdentificationEditable: MasterPermissions.CheckPermission(
            'Edit Registration Configuration',
          ),
          editReg: MasterPermissions.CheckPermission(
            'Edit Registration Configuration',
          ),
        });
      } else {
        this.setState({
          memberAndDependent: MasterPermissions.CheckPermission(
            'View Allowed User settings for Clients',
          ),
          waysOfRegistration: false,
          defaultPermission: MasterPermissions.CheckPermission(
            'View Allowed User settings for Clients',
          ),
          personalIdentification: false,
          dualCoverageRegistration: false,
          dualCoverageAffiliationPermission: false,
          dualCoverageApprovalPermission: false,
          memberAndDependentEditable: MasterPermissions.CheckPermission(
            'Edit Allowed Users settings for Clients',
          ),
          waysOfRegistrationEditable: false,
          defaultPermissionEditable: MasterPermissions.CheckPermission(
            'View Allowed User settings for Clients',
          ),
          personalIdentificationEditable: false,
          editReg: MasterPermissions.CheckPermission(
            'Edit Allowed Users settings for Clients',
          ),
        });
      }
    }
    this.forceUpdate();
  };

  rerenderPage = () => {
    this.forceUpdate();
  };

  handleWaysOfReg = (value) => {
    this.setState({ waysOfReg: [...value] });
  };

  loadDefaultPermissionHandler = (value) => {
    this.setState({
      loadDefaultPermission: value,
    });
  };

  schema = yup.object({
    //member and dependent
    //minAge: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Age must be greater than 0' )
    //.max( 100, 'Age must be less than or equal to 100' )
    //.required( 'Enter a number' ),
    //password policy
    //pwdRulesPasswordMinLength: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Attempts must be greater than 0' )
    //.max( 99, 'Attempts must be less than 100' )
    //.required( 'Enter a number' ),
    //pwdRulesPasswordMaxLength: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Attempts must be greater than 0' )
    //.max( 99, 'Attempts must be less than 100' )
    //.moreThan( yup.ref( 'pwdRulesPasswordMinLength' ), 'Max must be greater than min' )
    //.required( 'Enter a number' ),
    //pwdRulesNoOfInvalidAttempts: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Attempts must be greater than 0' )
    //.max( 99, 'Attempts must be less than 100' )
    //.required( 'Enter a number' ),
    //// one time password
    //OTPExpiresIn: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Duration must be greater than 0' )
    //.max( 999, 'Duration must be less than 1000' )
    //.required( 'Enter a number' ),
    //InvalidOTPAttempts: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Attempts must be greater than 0' )
    //.max( 99, 'Attempts must be less than 100' )
    //.required( 'Enter a number' ),
    //OTPLength: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 1, 'Length must be greater than 0' )
    //.max( 99, 'Length must be less than 100' )
    //.required( 'Enter a number' ),
    //FrequencyForTrustedDevice: yup
    //.number()
    //.typeError( 'Enter a number' )
    //.min( 0, 'Interval must be 0 or greater' )
    //.max( 999, 'Interval must be less than 100' )
  });

  render() {
    const {
      backtoDashboard,
      serverError,
      clientError,
      LoadingRegSetup,
      SavingRegSetup,

      //View Sections
      memberAndDependent,
      waysOfRegistration,
      defaultPermission,
      personalIdentification,
      dualCoverageRegistration,
      dualCoverageAffiliationPermission,
      dualCoverageApprovalPermission,

      //Edit Sections
      memberAndDependentEditable,
      waysOfRegistrationEditable,
      defaultPermissionEditable,
      personalIdentificationEditable,

      //Save Button
      editReg,
      errorValidation,
    } = this.state;

    if (serverError)
      return <Navigate to="/admin/server-error" push={true}></Navigate>;

    if (backtoDashboard) {
      return <Navigate to="/admin/dashboard" push={true}></Navigate>;
    }

    if (!MasterPermissions.CheckPermission('View Registration Configuration')) {
      return <Navigate to="/admin/server-error" push={true}></Navigate>;
    }

    return (
      <div>
        <Container fluid className="claims-details">
          {LoadingRegSetup && <RegistrationSetupSkeleton />}

          {!LoadingRegSetup && !clientError && (
            <div>
              <Header
                linkTo={'/admin/admin-dashboard'}
                header={'Configure Registration'}
              />

              <Formik
                validationSchema={this.schema}
                initialValues={{
                  //Member and Dependents
                  clientConfiguration: this.state.clientConfiguration,
                  allowMember: this.state.allowMember,
                  allowDependent: this.state.allowDependent,
                  minAge: this.state.minAge,

                  //Password Rules
                  //pwdRulesOid: this.state.pwdRulesOid,
                  //pwdRulesPasswordMinLength: this.state.wdRulesPasswordMinLength || 12,
                  //pwdRulesPasswordMaxLength: this.state.pwdRulesPasswordMaxLength || 18,
                  //pwdRulesNoOfUpperCaseReqd: this.state.pwdRulesNoOfUpperCaseReqd,
                  //pwdRulesNoOfLowerCaseReqd: this.state.pwdRulesNoOfLowerCaseReqd,
                  //pwdRulesNoOfNumericsReqd: this.state.pwdRulesNoOfNumericsReqd,
                  //pwdRulesNoOfSpecialCharactersReqd: this.state.pwdRulesNoOfSpecialCharactersReqd,
                  //dual coverage
                  whileRegistrationAffiliation:
                    this.state.whileRegistrationAffiliation,
                  postRegistrationAffiliation:
                    this.state.postRegistrationAffiliation,

                  //dual coverage registation
                  isRegistrationApproval: this.state.isRegistrationApproval,
                  selfAffiliation: this.state.selfAffiliation,

                  //pwdRulesRestrictQWERTYLetters: this.state.pwdRulesRestrictQWERTYLetters,
                  //pwdRulesAllowSpacesInPassword: this.state.pwdRulesAllowSpacesInPassword,
                  //pwdRulesNoOfLastPasswordsUsed: this.state.pwdRulesNoOfLastPasswordsUsed,
                  //pwdRulesAllowUnlockDisabledLogin: this.state.pwdRulesAllowUnlockDisabledLogin,
                  //JMP-1382 removed as per Amit's request
                  //pwdRulesNoOfInvalidPasswordRecoveries: this.state.pwdRulesNoOfInvalidPasswordRecoveries,
                  //pwdRulesNoOfInvalidAttempts: this.state.pwdRulesNoOfInvalidAttempts || 3,

                  //Two Factor Authentication
                  TwoFARequired: this.state.TwoFARequired,
                  //JMP-1301
                  OTPLength: this.state.OTPLength || 6,
                  OTPExpiresIn: this.state.OTPExpiresIn || 15,
                  FirstTimeRegistration: this.state.FirstTimeRegistration,
                  Login: this.state.Login,
                  FrequencyForTwoFA: this.state.FrequencyForTwoFA,
                  AllowSetTrustedDevice: this.state.AllowSetTrustedDevice,
                  FrequencyForTrustedDevice:
                    this.state.FrequencyForTrustedDevice,
                  FrequencyTypeForTrustedDevice:
                    this.state.FrequencyTypeForTrustedDevice || 30,
                  InvalidOTPAttempts: this.state.InvalidOTPAttempts || 3,
                }}
                enableReinitialize={true}
                onSubmit={(values, errors) => {
                  this.validateConfigFields(values, errors)
                    .then((res) => {
                      this.RegistrationSave(values);
                    })
                    .catch((res) => {});
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  isValid,
                }) => {
                  return (
                    <Form
                      onSubmit={handleSubmit}
                      className="border-right-after"
                    >
                      {memberAndDependent && (
                        <MemberAndDependent
                          values={values}
                          errors={errors}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          memberAndDependentEditable={
                            memberAndDependentEditable
                          }
                          rerenderPage={this.rerenderPage}
                          errorValidation={errorValidation}
                          loadDefaultPermissionHandler={
                            this.loadDefaultPermissionHandler
                          }
                          hasEditPermission={editReg}
                        />
                      )}

                      {dualCoverageAffiliationPermission ? (
                        <DualCoverageRegistration
                          values={values}
                          errors={errors}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          errorValidation={errorValidation}
                          loadDefaultPermissionHandler={
                            this.loadDefaultPermissionHandler
                          }
                          hasEditPermission={editReg}
                        />
                      ) : (
                        ''
                      )}
                      {dualCoverageApprovalPermission ? (
                        <ApprovalAffiliation
                          values={values}
                          errors={errors}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          errorValidation={errorValidation}
                          loadDefaultPermissionHandler={
                            this.loadDefaultPermissionHandler
                          }
                          hasEditPermission={editReg}
                        />
                      ) : (
                        ''
                      )}

                      {defaultPermission && (
                        <DefaultPermission
                          values={values}
                          errors={errors}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          setDefaultRole={this.setDefaultRole}
                          defaultMemberRole={this.state.defaultMemberRole}
                          defaultDependentRole={this.state.defaultDependentRole}
                          defaultPermissionEditable={defaultPermissionEditable}
                          loadDefaultPermission={
                            this.state.loadDefaultPermission
                          }
                          hasEditPermission={editReg}
                        />
                      )}

                      {waysOfRegistration && (
                        <WaysOfRegistration
                          values={values}
                          errors={errors}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          waysOfRegistrationEditable={
                            waysOfRegistrationEditable
                          }
                          handleWaysOfReg={this.handleWaysOfReg}
                          errorValidation={errorValidation}
                          hasEditPermission={editReg}
                        />
                      )}

                      {personalIdentification && (
                        <PersonalIdentification
                          values={values}
                          errors={errors}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          personalIdentificationEditable={
                            personalIdentificationEditable
                          }
                          waysOfReg={this.state.waysOfReg}
                          errorValidation={errorValidation}
                          hasEditPermission={editReg}
                        />
                      )}

                      <Row className="Payment-details password-policy border-bottom-0">
                        {/*editReg &&
                        ( <Col className="float-right text-right">

                          <GenericButton
                            disable={SavingRegSetup}
                            postLabel="SAVE"
                            onClick={handleSubmit}
                            buttonDisabled={!MasterPermissions.CheckPermission( 'Edit Registration Configuration' )}
                          >
                            SAVE
                          </GenericButton>
                  </Col> ) */}
                        <Col className="float-right text-right">
                          <GenericButton
                            disable={SavingRegSetup || !editReg}
                            postLabel="SAVE"
                            onClick={handleSubmit}
                            buttonDisabled={!editReg}
                          >
                            SAVE
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          )}
          {!LoadingRegSetup && clientError && <ClientError />}

          {SavingRegSetup && (
            <div className="custom-loader mt-0 d-flex justify-content-end sr-only">
              <div className="loader-icon position-relative mr-4">
                <Loader
                  className="text-dark font-weight-bold loader-color marginTop-Login-loader"
                  size="small"
                  active
                />
              </div>
              <div className="text-dark font-weight-bold" role="alert">
                Saving Registration Setup<span aria-hidden={true}>...</span>
              </div>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ breadCrumb }) => {
  const { blockOfBusiness, location, employer } = breadCrumb;
  return {
    blockOfBusiness,
    location,
    employer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    disableBreadCrumb: (data) => {
      dispatch(disableBreadCrumb(data));
    },
    resetBreadCrumb: (data) => {
      dispatch(resetBreadCrumb(data));
    },
    enableBreadCrumb: (data) => {
      dispatch(enableBreadCrumb(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationSetUp);
